import React from 'react';
import SEO from '../components/SEO';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Mantra from '../components/Mantra';
import Footer from '../components/Footer';
import Gallery from '../components/Gallery';
import CTA from '../components/CTA';
import '../styles/App.css';
import MantraImage from '../assets/images/Mantra_2.png';
import HeroImage from '../assets/images/HeroGym.png';
import CTAImage from '../assets/images/vb_coach.png';

// Import facility gallery images
import Img1 from "../assets/images/facility/01.png";
import Img2 from "../assets/images/facility/02.png";
import Img3 from "../assets/images/facility/03.png";
import Img4 from "../assets/images/facility/04.png";
import Img5 from "../assets/images/facility/05.png";


function Facility() {
 
     

  return (
	<div className="home">
	  <SEO
		title="Our Facility"
		description="Our facility is designed to meet the needs of coaches and athletes alike, offering four specialized training areas near I-35 & Hefner Rd in Oklahoma City."
		image="/og-images/facility.png"
		path="/facility"
	  />
	  <Header />
	  <main>
	  <Hero
		backgroundImage={HeroImage}
		headerText={
		  <>
			Our<br /><span style={{ color: 'red' }}>Facility</span>
		  </>
		}
		paragraphText={
		  <>
			<p>We are designing our facility to meet the needs of coaches and athletes alike, offering four specialized training areas.</p>

			<ul>
			<li>Coming Soon</li>
			<li>Near I-35 & Hefner Rd</li>
			<li>Oklahoma City, OK</li>
			</ul>
			<p></p>
			<ul>
			<li>Interested in how you can help?</li>
			<li>sam@beginthework.com</li>
			</ul>
			
		  </>
		}
		primaryButtonText="Plans & Pricing"
		primaryButtonLink="/plans"

	  />
	  {/* New Scrollable Gallery */}
	 <Gallery
	   images={[Img1, Img2, Img3, Img4, Img5]}
	   headerText={
		 <>
		   Concepts<br /><span style={{ color: 'red' }}>& Renders</span>
		 </>
	   }
	   paragraphText="We’re building a facility designed for real coaching and real training. Here’s a glimpse of what could be."
	 />
	 
	  <CTA
		title={
		  <>
		  Are You A <span style={{ color: 'red' }}>Coach</span>
		  </>
		  }
		description={
		<>
		<p>We are looking for coaches who need a home gym to coach their athletes in strength and fitness. We will offer NIKE Strength equipped collegiate level gym, a yoga and HIIT class section, a regulation volleyball court, and an outside turf field.</p>
		</>
	  }
		imageSrc={CTAImage}
		primaryButtonText="Send Info"
		primaryButtonLink=""
	  />
		<Mantra
		  backgroundImage={MantraImage}
		  mantraText="Seven Days Off makes One Weak"
		/>
		<Footer />
	  </main>
	</div>
  );
}

export default Facility;